<template>
    <div>
        <h3 class="h5 mb-3">{{ trans('dashboard.asset_management.title') }}</h3>
        <div class="db-card">
            <row>
                <column md="4">
                    <DashboardAssetTotal :total="$page.props.metrics?.totalAssets" />
                </column>
                <column md="8">
                    <AssetTypeDistribution
                        :assets-by-type="$page.props.metrics?.assetsByType.data"
                        style="min-height: 140px"
                        @selected="$emit('selected', $event)"
                    />
                </column>
            </row>
            <div class="divider border-top my-3" />
            <row>
                <column>
                    <AssetStatus
                        :active-filters="activeFilters"
                        :inoperable-assets="$page.props.metrics?.inoperableAssetsCount"
                        :is-processing="isProcessing"
                        :operable-assets="$page.props.metrics?.operableAssetsCount"
                        @filter="$emit('filter', $event)"
                    />
                </column>
            </row>
            <row class="mt-sm-2 mt-4">
                <column>
                    <asset-status-details />
                </column>
            </row>
        </div>
    </div>
</template>
<script>
import DashboardAssetTotal from '@/Pages/Dashboard/Components/AssetTotal.vue';
import AssetTypeDistribution from '@/Pages/Dashboard/Components/AssetTypeDistribution.vue';
import AssetStatus from '@/Pages/Dashboard/Components/AssetStatus/Main.vue';
import AssetStatusDetails from '@/Pages/Dashboard/Components/AssetStatus/Details.vue';
import { CCol } from '@coreui/vue/dist/esm/components/grid/index.js';

export default {
    name: 'AssetManagement',
    components: {
        CCol,

        AssetStatusDetails,
        AssetStatus,
        AssetTypeDistribution,
        DashboardAssetTotal,
    },
    props: {
        isProcessing: {
            type: Boolean,
            default: false,
        },
        activeFilters: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
